import React, { useContext } from "react";
import Chart from "react-apexcharts";
import { ThemeContext } from "../layout/themeContext";
import LEVELS from "./levels";

const SatisfactionChart = ({ printerData }) => {
  const { theme } = useContext(ThemeContext);
  if (!printerData || printerData.length === 0) {
    return (
      <div className="text-gray-600 dark:text-gray-400">No data available</div>
    );
  }
  const categories = printerData.map(
    (item) => `${item.printerName} - ${item.location}`
  );

  // One stacked segment per kiosk face, 1 very bad ... 5 excellent
  const series = LEVELS.map(({ name, key }) => ({
    name,
    data: printerData.map((item) => item.points?.[key] ?? 0),
  }));

  const options = {
    chart: {
      type: "bar",
      stacked: true,
      background: "transparent",
      toolbar: {
        show: false,
      },
    },
    theme: {
      mode: theme === "dark" ? "dark" : "light",
    },
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
    xaxis: {
      categories: categories,
      // Long kiosk names are cut short with an ellipsis instead of running off the
      // chart's edge; the tooltip still shows the whole name
      labels: {
        trim: true,
        maxHeight: 110,
      },
    },
    yaxis: {
      forceNiceScale: true,
      labels: {
        formatter: function (value) {
          return new Intl.NumberFormat("en-US").format(value);
        },
      },
    },
    tooltip: {
      y: {
        formatter: function (value, { dataPointIndex }) {
          const average = printerData[dataPointIndex]?.average;
          return `${new Intl.NumberFormat("en-US").format(
            value
          )} (avg ${average} / 5)`;
        },
      },
    },
    legend: {
      position: "top",
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return new Intl.NumberFormat("en-US").format(val);
      },
      style: {
        colors: ["#fff"],
      },
    },
    colors: LEVELS.map(({ color }) => color),
  };

  return (
    <div className="w-full p-4 bg-white rounded-lg shadow-xs dark:bg-gray-800">
      <Chart options={options} series={series} type="bar" height="400" />
    </div>
  );
};

export default SatisfactionChart;
